import { convertLengthToFeetAndInches } from '@vestico/utils';

import {
  BraSizeSource,
  ClientMatchedResponse,
  ClientReviewResponse,
  HeightUnit,
  ProductBase,
  convertStandardizedBraSize,
  isApparelMatchingCategory,
} from '@vestico/model';

import { i18n } from '@vestico/i18n';

export const sizeString = (size: string): string => {
  if (size.length > 3) {
    return size;
  }
  return i18n.t('LOC_FIT_REVIEW_SIZE_WORN', { size, ns: 'shared' });
};

export const heightString = (response: ClientReviewResponse, unit: HeightUnit): string | null => {
  if (!response) {
    return null;
  }
  const { height } = response;
  if (!height) {
    return null;
  }

  if (unit === HeightUnit.feet) {
    const feetAndInches = convertLengthToFeetAndInches(height);
    const feet = feetAndInches[0];
    const inches = feetAndInches[1];
    return i18n.t('LOC_FIT_REVIEW_BODY_DOUBLE_HEIGHT_FT_IN', { value_ft: feet, value_in: inches, ns: 'shared' });
  }
  return i18n.t('LOC_FIT_REVIEW_BODY_DOUBLE_HEIGHT_CM', { value: height, ns: 'shared' });
};

export const braSizeString = (response: ClientMatchedResponse, unit: BraSizeSource | null): string | null => {
  if (!response || !unit) {
    return null;
  }
  const { braSizeBand, braSizeCup } = response;
  if (!braSizeCup || !braSizeBand) {
    return null;
  }

  const braSize = convertStandardizedBraSize(unit, braSizeBand, braSizeCup);
  return `${braSize.band.displayValue}${braSize.cup.displayValue}`;
};

export const matchPercentageString = (response: ClientMatchedResponse, product?: ProductBase | null | undefined): string | null => {
  if (!response) {
    return null;
  }
  const { matchValue, hideMatchValue } = response;
  if (!matchValue || hideMatchValue) {
    return null;
  }

  if (!isApparelMatchingCategory(product?.matchingCategory)) {
    return i18n.t('LOC_FIT_REVIEW_MATCH', { value: matchValue, ns: 'shared' });
  }

  return i18n.t('LOC_FIT_REVIEW_BODY_DOUBLE_MATCH', { value: matchValue, ns: 'shared' });
};

export const weightMatchPercentageString = (response: ClientMatchedResponse): string | null => {
  if (!response) {
    return null;
  }
  const { weightMatchValue } = response;
  if (!weightMatchValue) {
    return null;
  }
  return i18n.t('LOC_FIT_REVIEW_MATCH', { value: weightMatchValue, ns: 'shared' });
};
